import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { formatRMVValue } from 'utils/number-format.utils';

import RMVIcon from 'assets/menu/icons/RMV.svg';

/**
 * Formats a string containing an RMV value (e.g. "1000 RMV", "68.75 RMV", or plain "248")
 * into a ReactNode with the RMV token icon and formatted number.
 * Returns the original text if it doesn't match the expected pattern.
 */
export const formatRMVWithIcon = (text: string, iconClassName?: string): ReactNode => {
  const match = text.match(/^([\d.]+)(\s+RMV)?$/);
  if (match) {
    const numValue = parseFloat(match[1]);
    return (
      <span className="tw-inline-flex tw-items-center tw-justify-center tw-gap-[4px]">
        <img src={RMVIcon} alt="RMV" className={twMerge('tw-h-[18px] tw-w-[18px]', iconClassName)} />
        {formatRMVValue(numValue)}
      </span>
    );
  }
  return text;
};
